module.exports = __webpack_public_path__ + "img/c4.a3bfa4f0.jpg";